module.exports = ReactDOM;


//////////////////
// WEBPACK FOOTER
// external "ReactDOM"
// module id = 2
// module chunks = 0 1 2 3 4 5 6 7 8